import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const baseStyle = defineStyle({
    width: 'auto',
    borderRadius: '8px'
});

const variants = {
    primary: defineStyle({
        backgroundColor: 'primary.400',
        borderColor: 'primary.400',
        color: 'white',
        fontSize: '12px',
        _hover: {
            backgroundColor: 'primary.500',
            borderColor: 'primary.500',
            _disabled: {
                backgroundColor: 'primary.500'
            }
        }
    }),
    outline: defineStyle({
        backgroundColor: 'transparent',
        borderColor: 'primary.400',
        borderWidth: '1px',
        color: 'primary.400',
        fontSize: '12px',
        _hover: {
            backgroundColor: 'neutral.200'
        }
    }),
    secondary: defineStyle({
        backgroundColor: 'transparent',
        color: 'primary.400',
        fontSize: '12px',
        _hover: {
            backgroundColor: 'neutral.200'
        }
    }),
    destructive: defineStyle({
        backgroundColor: 'error.400',
        color: 'white',
        fontSize: '12px',
        _hover: {
            backgroundColor: 'error.600',
            _disabled: {
                backgroundColor: 'error.600'
            }
        }
    }),
    ghost: defineStyle({
        backgroundColor: 'transparent',
        fontSize: '12px',
        _hover: {
            backgroundColor: 'neutral.100'
        }
    }),
    iconPagination: defineStyle({
        color: 'neutral.300',
        height: '20px',
        minWidth: 'unset',
        padding: 0,
        width: '20px',
        '&.left': {
            transform: 'rotate(180deg)'
        },
        '& > svg': {
            height: '20px',
            width: '20px'
        }
    })
};

export const buttonTheme = defineStyleConfig({
    baseStyle,
    variants
});
